import {
  ReportSummaryHeader,
  ReportSummaryKpiSection,
  ReportSummaryRevenueOverviewSection,
  ReportSummaryCategorySection,
  ReportSummaryTrendsSection,
  ReportSummaryTransactionSection,
  ReportSummaryInsightsSection,
  ReportSummaryMarketSection,
  getDailyRevenue,
} from "../../../components/reportDashboard/reportSummary/reportSummarySections";
import {
  useFlightRevenueByAirline,
  useFlightSummaryMetrics,
  useReportDateRange,
  useRevenueBycategory,
  useRevenueByGeography,
  useRevenuetrends,
  useSummaryMetrics,
  useTopRevenueAgents,
  useTransaction,
} from "../../../hooks/useReportDashboard";
import { getErrorMessage } from "../../../utils/error";

export default function ReportSummary() {
  const { dateRange, onDateRangeChange } = useReportDateRange();

  const {
    data: summaryData,
    isLoading: summaryLoading,
    isError: summaryError,
    error: summaryErrObj,
    refetch: summaryRefetch,
  } = useSummaryMetrics(dateRange);

  const {
    data: trendsData,
    isLoading: trendsLoading,
    isError: trendsError,
    error: trendsErrObj,
    refetch: trendsRefetch,
  } = useRevenuetrends(dateRange);

  const {
    data: revenueAgents,
    isLoading: revenueAgentsLoading,
    isError: revenueAgentsError,
    error: revenueAgentsErrObj,
    refetch: revenueAgentsRefetch,
  } = useTopRevenueAgents(dateRange);

  const {
    data: categoryData,
    isLoading: categoryLoading,
    isError: categoryError,
    error: categoryErrObj,
    refetch: categoryRefetch,
  } = useRevenueBycategory(dateRange);

  const {
    data: flightRevenue,
    isLoading: flightRevenueLoading,
    isError: flightRevenueError,
    error: flightRevenueErrObj,
    refetch: flightRevenueRefetch,
  } = useFlightRevenueByAirline(dateRange);

  const {
    data: revenueByGeo,
    isLoading: revenueGeoLoading,
    isError: revenueGeoError,
    error: revenueGeoErrObj,
    refetch: revenueGeoRefetch,
  } = useRevenueByGeography(dateRange);

  const {
    data: flightSummaryData,
    isLoading: flightSummaryLoading,
    isError: flightSummaryError,
    error: flightSummaryErrObj,
    refetch: flightSummaryRefetch,
  } = useFlightSummaryMetrics(dateRange);

  const {
    data: transactionData,
    isLoading: transactionLoading,
  } = useTransaction(dateRange);

  const summaryState = {
    loading: summaryLoading,
    error: summaryError,
    message: getErrorMessage(summaryErrObj),
    onRetry: () => summaryRefetch(),
  };

  const trendsState = {
    loading: trendsLoading,
    error: trendsError,
    message: getErrorMessage(trendsErrObj),
    onRetry: () => trendsRefetch(),
  };

  const revenueAgentsState = {
    loading: revenueAgentsLoading,
    error: revenueAgentsError,
    message: getErrorMessage(revenueAgentsErrObj),
    onRetry: () => revenueAgentsRefetch(),
  };

  const categoryState = {
    loading: categoryLoading,
    error: categoryError,
    message: getErrorMessage(categoryErrObj),
    onRetry: () => categoryRefetch(),
  };

  const flightRevenueState = {
    loading: flightRevenueLoading,
    error: flightRevenueError,
    message: getErrorMessage(flightRevenueErrObj),
    onRetry: () => flightRevenueRefetch(),
  };

  const revenueGeoState = {
    loading: revenueGeoLoading,
    error: revenueGeoError,
    message: getErrorMessage(revenueGeoErrObj),
    onRetry: () => revenueGeoRefetch(),
  };

  const flightSummaryState = {
    loading: flightSummaryLoading,
    error: flightSummaryError,
    message: getErrorMessage(flightSummaryErrObj),
    onRetry: () => flightSummaryRefetch(),
  };

  const summaryMetrics = Object.values(summaryData?.data || {});
  const dailyRevenue = getDailyRevenue(flightSummaryData);
  const categoryMetrics = categoryData?.data || [];
  const trendDatasets = trendsData?.data?.datasets || [];
  const topRevenueAgents = revenueAgents?.data || [];
  const revenueByGeography = revenueByGeo?.data || [];
  const flightRevenueByAirline = flightRevenue?.data || [];
  const transactionRows = transactionData?.data?.data;

  return (
    <div className="space-y-6">
      <ReportSummaryHeader onDateRangeChange={onDateRangeChange} />

      <ReportSummaryKpiSection
        state={summaryState}
        summaryMetrics={summaryMetrics}
      />

      <ReportSummaryRevenueOverviewSection
        flightSummaryState={flightSummaryState}
        categoryState={categoryState}
        dailyRevenue={dailyRevenue}
        categoryData={categoryMetrics}
      />

      <ReportSummaryCategorySection
        state={categoryState}
        categoryData={categoryMetrics}
      />

      <ReportSummaryTrendsSection
        state={trendsState}
        trendsData={trendDatasets}
      />

      <ReportSummaryTransactionSection
        transactionData={transactionRows}
        isLoading={transactionLoading}
      />

      <ReportSummaryInsightsSection
        revenueAgentsState={revenueAgentsState}
        revenueAgents={topRevenueAgents}
        categoryState={categoryState}
        categoryData={categoryMetrics}
      />

      <ReportSummaryMarketSection
        revenueGeoState={revenueGeoState}
        revenueByGeo={revenueByGeography}
        flightRevenueState={flightRevenueState}
        flightRevenue={flightRevenueByAirline}
      />
    </div>
  );
}
